import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { featchFunelList } from './action'

/**
 * @interface
 */
const initialState = {
    loading: 'idle',
    entities: [],
    totalCount: 0,
    filters: {},
    pagination: {
        sizePerPage: 10,
        page: 1
    },
    error: null
}

export const FunnelSlice = createSlice({
    name: 'Funil',
    initialState,
    reducers: {
        changePagination: ( state, { payload }) => {
            state.pagination = payload
        },
        setFilterBy: (state, { payload }) => {
            state.filters = payload
        },
        clearFilters: (state, { payload }) => {
            state.filters = {}
        }
    },
    extraReducers: build => {
        build.addCase(featchFunelList.pending, (state) => {
            if ( state.loading === 'idle' ) {
                state.loading = 'loading'
            }
        })
        .addCase(featchFunelList.rejected, ( state, { payload } ) => {
            if ( state.loading === 'loading' ) {
                state.error = payload
                state.loading = 'idle'
            }
        })
        .addCase(featchFunelList.fulfilled, ( state, { payload } ) => {
            if ( state.loading === 'loading' ) {
                state.loading = 'idle'
                state.entities = payload.entities
                state.totalCount = payload.total
            }
        })
    }
})

/**
 * 
 */
export const {
    changePagination,
    clearFilters,
    setFilterBy
} = FunnelSlice.actions


/**
 * 
 * @returns {initialState}
 */
export const useFunnelSelector = () => useSelector(state => state.funnel)

/**
 * 
 */
export default FunnelSlice.reducer